import { computed, getCurrentInstance, ref, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
export function useTab(emit) {
  const { proxy } = getCurrentInstance()
  const router = useRouter()
  const route = useRoute()

  const openMenuList = computed(() => proxy.$store.state.menuStore.pageOpenedList)
  const currentRouter = computed(() => proxy.$store.state.menuStore.currentRouter)
  const onCommand = (command) => {
    if (command === 'all') {
      proxy.$store.commit('clearAllTags')
      if (route.name !== 'home_index') {
        router.push({ name: 'home_index' })
      }
    } else {
      proxy.$store.commit('clearOtherTags')
    }
  }
  const onTabChange = (menu) => {
    //模拟body点击事件，解决路由切换的时候下拉列表未消失
    // document.body.click()
    if (currentRouter.value.id === menu.id) return
    const routerObj = {}
    routerObj.name = menu.name
    if (menu.argu) {
      routerObj.params = menu.argu
    }
    if (!routerObj.params) routerObj.params = {}
    routerObj.params._cachePage = true
    if (menu.query) {
      routerObj.query = menu.query
    }
    for (let routerItem of openMenuList.value) {
      if (menu.name == routerItem.name) {
        proxy.$cfn?.setNeedCache(true, routerItem.id)
      }
    }
    proxy.$store.commit('setNeedKeepAlive', true)
    router.push(routerObj)
  }
  const closeTab = (id) => {
    let lastPageObj = null
    if (currentRouter.value && currentRouter.value.id === id) {
      let len = openMenuList.value.length
      for (let i = 0; i < len; i++) {
        if (openMenuList.value[i].id === id) {
          if (i < len - 1) {
            lastPageObj = openMenuList.value[i + 1]
          } else {
            lastPageObj = openMenuList.value[i - 1]
          }
          break
        }
      }
    }
    proxy.$store.commit('closeTabByname', { id: id, vm: proxy })
    // 关闭的当前页，则跳转到上次记录
    if (currentRouter.value.id === id) {
      onTabChange(lastPageObj)
    }
  }
  const onClose = (menu) => {
    proxy.$store.commit('scanUtilsEmit', 'close-page-ev')
    proxy.$cfn.formModify.switchRouteHandle(
      menu.id,
      () => {
        closeTab(menu.id)
      },
      proxy
    )
  }
  const routerViewShow = ref(true)
  const onRefresh = (name) => {
    routerViewShow.value = false
    proxy.$store.commit('checkKeepAlive', currentRouter.value)
    proxy.$store.commit('setNeedKeepAlive', true)
    nextTick(() => {
      window?.localCacheMemory?.keys((value, key) => {
        if (key.indexOf(name) > -1) {
          window.localCacheMemory.removeItem(key)
        }
      })
      routerViewShow.value = true
      proxy.$store.commit('setKeepAliveInclude', currentRouter.value)
      emit('refrash')
    })
  }
  const onSortable = (event) => {
    proxy.$store.commit('setTagOrder', event)
  }

  return {
    openMenuList,
    currentRouter,
    onCommand,
    onTabChange,
    onClose,
    routerViewShow,
    onRefresh,
    onSortable,
  }
}
